import { useEffect } from 'react';

interface IUseBlockExernalNavigationProps {
  blockNavigation: boolean;
}

/**
 * Adds listener to block external navigation (reloads or navigation to other domains)
 * Uses browser's default pop-up to confirm navigation
 *
 * @returns {void}
 */
const useBlockExternalNavigation = ({
  blockNavigation
}: IUseBlockExernalNavigationProps): void => {
  const handleExternalNavigation = (e: {
    preventDefault: () => void;
    returnValue: string;
  }) => {
    if (!blockNavigation) return;
    e.preventDefault();
    return (e.returnValue = '');
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleExternalNavigation, {
      capture: true
    });
    return () => {
      window.removeEventListener('beforeunload', handleExternalNavigation, {
        capture: true
      });
    };
  }, [blockNavigation]);
};

export default useBlockExternalNavigation;
